export const handleScroll = (
  scrollTarget: HTMLElement,
  updatePositionCallback: () => void,
  hideMenuCallback: () => void,
): void => {
  updatePositionCallback()

  const rect = scrollTarget.getBoundingClientRect()

  const isParentVisible =
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  if (!isParentVisible) {
    hideMenuCallback()
  }
}
